import {ENV} from "../../configs/settings";
import React from "react";

const SpanEnv = (className) => {
  if (ENV === 'development' || ENV === 'staging') {
    return <span className={`${className} lg:text-[16px] text-[14px] absolute lg:left-1/2 left-[316px] transform -translate-x-1/2 lg:w-[200px] w-[112px] py-2 text-center bg-red-500 text-white uppercase`}>{ENV}</span>
  }

  return null;
};

export default SpanEnv;